/**
 * Converts an SVG data URL to a PNG data URL
 * @param {string} svgDataUrl - The SVG data URL (data:image/svg+xml;base64,...)
 * @param {number} scaleFactor - Scale factor for higher resolution (default: 2x for retina displays)
 * @returns {Promise<string>} PNG data URL
 */
export default function convertSvgToPng(svgDataUrl, scaleFactor = 2) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    
    img.onload = () => {
      try {
        // Create an offscreen canvas
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        // Set canvas dimensions with scale factor for better quality
        canvas.width = img.width * scaleFactor;
        canvas.height = img.height * scaleFactor;
        
        // Scale context to match
        ctx.scale(scaleFactor, scaleFactor);
        
        // Draw the SVG image onto the canvas
        ctx.drawImage(img, 0, 0);
        
        // Convert canvas to PNG data URL
        const pngDataUrl = canvas.toDataURL('image/png');
        
        resolve(pngDataUrl);
      } catch (error) {
        reject(new Error(`Failed to convert SVG to PNG: ${error.message}`));
      }
    };
    
    img.onerror = () => {
      reject(new Error('Failed to load SVG image'));
    };
    
    // Set crossOrigin to handle CORS if needed
    img.crossOrigin = 'anonymous';
    
    // Load the SVG data URL
    img.src = svgDataUrl;
  });
}
